var map = {
	"./map-icon-0.png": "8b33",
	"./map-icon-1.png": "4507",
	"./map-icon-2.png": "9bf7",
	"./map-icon-3.png": "da44",
	"./map-icon-4.png": "bf6b",
	"./map-icon-5.png": "789d",
	"./map-icon-6.png": "afdf",
	"./map-icon-7.png": "1435",
	"./map-icon-menu.png": "07a1"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "cb1e";